// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"e2ff468f85--tooltip--Jsh1z","arrow_tooltip":"e2ff468f85--arrow_tooltip--SRU9V","arrow":"e2ff468f85--arrow--A4pue"};